import React from 'react'
import gsap from 'gsap'

export const formatDate = (date: string, separator = '/', pad = false): string => {
    const d = new Date(date)
    const formatValue = (unit: number) => `${unit}`.padStart(2, pad ? '0' : '')

    return `${formatValue(d.getDate())}${separator}${formatValue(d.getMonth() + 1)}${separator}${d.getFullYear()}`
}

// 00:00{:00} or 00:00{:00} am/pm
export const formatTime = (date: string, showSeconds = false, separator = ':', is24Hour = true): string => {
    const d = new Date(date)
    const padTime = (unit: number) => `${unit}`.padStart(2, '0')
    const hours = is24Hour ? d.getHours() : d.getHours() % 12 || 12
    const seconds = showSeconds ? `${separator}${padTime(d.getSeconds())}` : ''
    const suffix = is24Hour ? '' : d.getHours() >= 12 ? ' pm' : ' am'

    return `${padTime(hours)}${separator}${padTime(d.getMinutes())}${seconds}${suffix}`
}

export function getLocalStorageFlagValue(key: string, defaultValue: boolean): boolean {
    try {
        return localStorage.getItem(key) === 'true'
    } catch {
        return defaultValue
    }
}

export const fadeGSAPAnimation = (show: boolean, targets: HTMLDivElement[], duration = 0.1, ease = 'linear') => {
    return gsap.to(targets, {
        opacity: Number(show),
        ease,
        duration,
        onStart: () => {
            if (show) {
                targets.forEach((t) => {
                    t.style.visibility = 'visible'
                    t.inert = false
                })
            }
        },
        onComplete: () => {
            if (!show) {
                targets.forEach((t) => {
                    t.style.visibility = 'hidden'
                    t.inert = true
                })
            }
        },
    })
}

export const withAutoBlur = (fn: (e?: React.MouseEvent<HTMLButtonElement>) => void) => {
    return (e?: React.MouseEvent<HTMLButtonElement>) => {
        if (e?.button === 2) return

        // needed because of an issue with some browsers extensions monkeypatching dom elements
        // and causing click events to be triggered - STEAL-5413
        if (!e?.isTrusted) return

        e?.currentTarget.blur()
        fn(e)
    }
}

export const extractScale = (style: string): number | null => {
    const match = style.match(/scale-\[(.*?)\]/)

    return match ? Number(match[1]) : null
}

export const patchPaytableUrl = (language: string) => {
    const params = new URLSearchParams(window.location.search)

    const raw = params.get('paytableUrl')

    if (!raw) return

    const decoded = decodeURIComponent(raw)

    const lang = language.slice(0, 2).toLowerCase()

    const patched = decoded.replace(/\/[a-z]{2}\.html(?=\?)/i, `/${lang}.html`)

    params.set('paytableUrl', patched)

    window.history.replaceState({}, '', `?${params.toString()}`)
}

export const wait = (duration: number) => new Promise((resolve) => setTimeout(resolve, duration))
